@switch (engine) {
  @case ("tiny") {
    <div class="relative flex flex-1">
      @if (tinyLoading()) {
        <div
          class="absolute inset-0 z-10 flex items-center justify-center bg-slate-50"
        >
          <dx-load-indicator></dx-load-indicator>
        </div>
      }

      <div
        tinyeditor
        [init]="tinyEditorOptions()"
        [maxImageSize]="maxImageSize"
        [containerMode]="containerMode"
        [readOnly]="readOnly"
        class="flex-1"
        (contentChanged)="contentChanged.emit()"
        (editorReady)="onTinyEditorReady()"
        (editorRendered)="onTinyEditorRendered()"
      ></div>
    </div>
  }
  @case ("devx") {
    <dx-html-editor
      [value]="initialContent"
      [toolbar]="devxEditorToolbar()"
      [placeholder]="placeholder"
      [readOnly]="readOnly"
      class="flex-1 bg-white"
      (onContentReady)="onDevxContentReady($event)"
      (valueChange)="contentChanged.emit()"
    >
      @if (variablesEnabled()) {
        <dxo-variables
          [dataSource]="variablesDataSource()"
          [escapeChar]="variablesEscapeChar()"
        ></dxo-variables>
      }
    </dx-html-editor>
  }
}
